import { Stack, Typography } from '@mui/material';
import { Subtitle, StyledButton } from './EmptyState.styles';

export type EmptyStateProps = {
  title: string;
  description?: string;
  isShowButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
};

export default function EmptyState({
  title,
  description,
  isShowButton = true,
  buttonText,
  onButtonClick,
}: EmptyStateProps) {
  return (
    <Stack
      data-testid='empty-state'
      alignItems='center'
      justifyContent='center'
      padding={2}
      height='100%'
      spacing={3}
    >
      <Typography component='h3' variant='h3'>
        {title}
      </Typography>
      {description && <Subtitle>{description}</Subtitle>}
      {isShowButton && (
        <StyledButton
          data-testid='empty-state-button'
          variant='contained'
          color='primary'
          size='large'
          onClick={onButtonClick}
        >
          {buttonText}
        </StyledButton>
      )}
    </Stack>
  );
}
